import BoxHero from './BoxHero.component';

export default BoxHero;